/**
 * Категории «Картотека» — смысловые пары bg/fg (§3.3).
 * Каждая категория = CSS-класс cat-* (tokens.css), выставляющий --cb/--cf.
 * Используется тактильными примитивами: CategoryTile, TactileToken, CardDeck, TiltCard.
 */
export type Category =
	| "streak" // серия (тёплый акцент)
	| "cards" // карточки / повторение
	| "mastery" // прогресс / готовность
	| "time" // время / нейтральное
	| "quiz" // тесты
	| "ai" // AI / рекомендации
	| "text" // TEXT-материалы
	| "doc" // DOC-материалы
	| "image"; // IMAGE-материалы

/** Маппинг категории → CSS-класс cat-* (выставляет --cb/--cf). */
export const CATEGORY_CLASS: Record<Category, string> = {
	streak: "cat-streak",
	cards: "cat-cards",
	mastery: "cat-mastery",
	time: "cat-time",
	quiz: "cat-quiz",
	ai: "cat-ai",
	text: "cat-text",
	doc: "cat-doc",
	image: "cat-image",
};
